import React, { useState } from 'react';
import CountryPopup from '../Site/CountryPopup'; // Import the CountryPopup component

const CountrySelector: React.FC = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <div className="flex justify-center items-center">
      <button onClick={handleOpenPopup} className="flex items-center space-x-2 text-sm">
        <img src="/general/UK.svg" alt="UK Flag" className="w-5 h-5" />
        <span>UK</span>
      </button>

      <CountryPopup isOpen={isPopupOpen} onClose={handleClosePopup} />
    </div>
  );
};

export default CountrySelector;
